module.exports = __webpack_public_path__ + "static/media/other.273b0e33.svg";